import { azureStorageAuthTypes } from '../../interfaces/IAuthenticationType';
import { IPrivateEndpointCompatible } from '../../interfaces/IPrivateEndpointCompatible';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { IAttribute, IValidationContext } from '../base/annotation';
import { Metamodel } from '../base/model';
import { IModel, IViolation } from './../base/annotation';
import { IAzureBlobLinkedServiceValidators } from './azure-blob-fs.linkedservice';
import { AzureKeyVault } from './key-vault';
import { LinkedService } from './linkedservice';

export const azureBlobLinkedServiceValidators: IAzureBlobLinkedServiceValidators = {
    validateAKVLinkedserviceReference: undefined
};

@Metamodel.model({
    name: 'AzureStorage',
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AzureStorage_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AzureStorage_DisplayText)
    ]
})
export class AzureStorageLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly ACCOUNT_NAME: IAttribute;
    public static readonly ACCOUNT_KEY: IAttribute;
    public static readonly ENDPOINT_SUFFIX: IAttribute;
    public static readonly SAS_URI: IAttribute;
    public static readonly SAS_TOKEN: IAttribute;
    public static readonly PRIMARY_ENDPOINT: IAttribute;
    public static readonly ENABLE_PARTITIONED_DNS: IAttribute;

    public authenticationMethod?: string = azureStorageAuthTypes.AccountKeyAuthentication;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_PrimaryEndpoint,
        association: 'PRIMARY_ENDPOINT',
        templatable: true
    })
    public primaryEndpoint: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_StorageAccountName,
        association: 'ACCOUNT_NAME',
        templatable: true
    })
    public accountName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EndpointSuffix,
        association: 'ENDPOINT_SUFFIX',
        templatable: true
    })
    public endpointSuffix?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_StorageAccountKey,
        association: 'ACCOUNT_KEY',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public accountKey?: string | AzureKeyVault;

    public enableAccountAKV?: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_StorageAccountKey,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public referedAccountAKV?: AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasURI,
        association: 'SAS_URI',
        templatable: true
    })
    public sasUri?: string;
    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasURI,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public referedSasUriAKV?: AzureKeyVault;
    public enableSasUriAKV?: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SasToken,
        association: 'SAS_TOKEN',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        }
    })
    public sasToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_PARTITIONED_DNS',
        display: shellStringResources.enablePartitionedDns
    })
    public isPartitionedDns?: boolean;

    protected _accountResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        const resourceName = this._getPEResourceName();
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }

    protected _getPEResourceName(): string {
        switch (this.authenticationMethod) {
            case azureStorageAuthTypes.AccountKeyAuthentication:
                return this.accountName || '';
            case azureStorageAuthTypes.SasUriAuthentication:
                if (this.sasUri && this.sasUri.toLowerCase().startsWith('https://')) {
                    return this.sasUri.substr(8).split('.')[0];
                }
                return '';
            default:
                return '';
        }
    }
}
